<template>
<div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
        <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>
    &nbsp;
    <!-- Container Utama -->
    <b-container fluid class="">
        <card header-classes="bg-transparent">

            <!-- Maklumat Penjawat Awam -->
            <div>
                <validation-observer v-slot="{ invalid }">
                    <b-form @submit.prevent="SimpanMaklumat">
                        <card header-classes="bg-transparent shadow-sm">
                            <h4 class="mb-0 text-center text-primary font-bold text-13136xl">
                                MAKLUMAT PENDAFTARAN PROFIL PEGAWAI
                            </h4>
                            <hr />
                            <div class="pl-lg-4">
                                <!-- No. Kad Pengenalan -->
                                <validation-provider name="NO KAD PENGENALAN" :rules="{ required: true ,no_kp: true  }" v-slot="validationContext">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">NO KAD PENGENALAN </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input v-model="ProfilAwam.NoKP" class="rounded" :state="getValidationStatePenjawat(validationContext)"></b-form-input>
                                            <b-form-invalid-feedback class="text-danger font-weight-bold" style="font-size:16px;">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Nama -->
                                <validation-provider name="NAMA" :rules="{ required: true ,nama_hanya_huruf: true }" v-slot="validationContext">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">NAMA </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="8">
                                            <b-form-input v-model="ProfilAwam.Nama" :state="getValidationStatePenjawat(validationContext)" class="rounded"></b-form-input>
                                            <b-form-invalid-feedback class="text-danger font-weight-bold" style="font-size:16px;">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }">
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> KLASIFIKASI PERKHIDMATAN AWAM LANTIKAN PERTAMA / PADA 31.12.2002 * </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row>
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }">
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> SKIM PERKHIDMATAN AWAM LANTIKAN PERTAMA / PADA 31.12.2002 * </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SchmOfServId" :options="SchmOfServList" style="width: 80%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="pilih skim" :rules="{ required: true }">
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> SISTEM SARAAN LANTIKAN PERTAMA / PADA 31.12.2002* </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="6">
                                            <b-form-select id="Pilih Skim" name="Pilih Skim" value-field="value" text-field="text" :options="skimOptions" v-model="ProfilAwam.id_SistemSaraan" @change="runMethod2()" style="width: 45%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }">
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold"> GRED JAWATAN LANTIKAN PERTAMA / PADA 31.12.2002* </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Gaji Lantikan Pertama" :rules="{ required: true }">
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold">GAJI LANTIKAN PERTAMA / PADA 31.12.2002* </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="4">
                                            <b-form-input v-model="ProfilAwam.SalGrdPertama"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <!-- Tarikh Lantikan Pertama -->
                                <validation-provider name="Tarikh Lantikan Pertama" :rules="{ required: true }">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">TARIKH LANTIKAN PERTAMA </b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input type="date" v-model="ProfilAwam.DtLantikanPertama" class="rounded shadow-sm"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                            </div>

                            <!-- Butang Simpan -->
                            <b-row class="justify-content-center mt-4">
                                <b-button variant="success" type="submit" :disabled="invalid" class="px-5">SIMPAN</b-button>
                            </b-row>
                        </card>
                    </b-form>
                </validation-observer>
            </div>
        </card>
    </b-container>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ruangan {_field_} wajib diisi.'
})

extend('no_kp', {
  validate: value => /^[0-9]{12}$/.test(value),
  message: 'No. KAD PENGENALAN 12 digit sahaja (contoh: 900101XXXXXX).'
})
// Rule: wajib isi & hanya huruf (tak boleh nombor)
extend('nama_hanya_huruf', {
  validate: value => {
    if (!value || !value.trim()) return false; // kosong → invalid
    return /^[A-Za-z\s/@]+$/.test(value);  // hanya huruf & space
  },
  message: 'Nama hanya boleh mengandungi huruf sahaja.'
})
export default {
    data() {
        return {

            ProfilAwam: {
                //StatusKGT2023: 1,
                // Nama: null,
            },
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            pegPengiraList: [{
                    value: 1,
                    text: "ABU",
                },
                {
                    value: 2,
                    text: "ALI",
                },
            ],
            skimOptions: [{
                    value: '2',
                    text: 'SSPA'
                },
                {
                    value: '1',
                    text: 'SSM'
                },
            ],

        };
    },
    methods: {
        getValidationStatePenjawat({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log("klas perkhidmatan", this.ServClassId);

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
                SchmOfServId: this.ProfilAwam.SchmOfServId,
                pilihSkim: this.ProfilAwam.id_SistemSaraan,
            };

            console.log("search", this.Search);

            GetselenggaraService.getSenaraiSalGrd(Search)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {
            console.log("ProfilAwam", this.ProfilAwam);

            let Search = {
                NoKP: this.ProfilAwam.NoKP,
                logStatusID: 0,
                //NoKP: 860610565253,
            };

            GetsalaryService.getStatusNOKp(Search)
                .then((resp) => {
                    this.StatusNokp = resp.data;
                    console.log("this.StatusNokp.Status", this.StatusNokp.Status);

                    if (this.StatusNokp.Status == 1) {
                        const swalWithBootstrapButtons = swal.mixin({
                            customClass: {
                                confirmButton: "btn btn-success",
                                cancelButton: "btn btn-danger",
                            },
                            buttonsStyling: false,
                        });
                        //console.log("Memanggil swal.fire...");
                        swalWithBootstrapButtons
                            .fire({
                                title: "ADAKAH ANDA PASTI?",
                                text: " No Kad Pengenalan Telah Wujud, Teruskan?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonText: "YA, TERUSKAN JANA",
                                cancelButtonText: "BATAL",
                                reverseButtons: true,
                            })
                            .then((result) => {
                                console.log("Hasil SweetAlert:", result);
                                if (result.isConfirmed) {
                                    console.log("Menghantar data ke servis...");
                                    GetsalaryService.setMaklPenjawatAwam(this.ProfilAwam)
                                        .then((resp) => {
                                            console.log("Servis berjaya:", resp);
                                            //this.simpanbutiran();
                                            swalWithBootstrapButtons
                                                .fire({
                                                    title: "BERJAYA DI SIMPAN!",
                                                    text: "KLIK OK UNTUK TERUSKAN.",
                                                    icon: "success",
                                                })
                                                .then(() => {
                                                    this.$router.push({
                                                        name: "BUTIRAN MAKLUMAT PERIBADI",
                                                        params: {
                                                            ICNo: this.ProfilAwam.NoKP,
                                                        },
                                                    });
                                                });
                                        })
                                        .catch((err) => {
                                            console.log("err:", err.response);
                                        });
                                } else if (
                                    /* Read more about handling dismissals below */
                                    result.dismiss === swal.DismissReason.cancel
                                ) {
                                    swalWithBootstrapButtons
                                        .fire({
                                            title: "BATAL",
                                            text: " Proses Janaan Maklumat Pegawai Dibatalkan.",
                                            icon: "error",
                                        })
                                        .then(() => {
                                            this.$router.push({
                                                name: "DASHBOARD KIRAAN GAJI",
                                                // params: {
                                                //     ICNo: this.ProfilAwam.NoKP,
                                                // },
                                            });
                                        });
                                }
                            });
                    } else if (this.StatusNokp.Status == 2) {
                        GetsalaryService.setMaklPenjawatAwam(this.ProfilAwam)
                            .then((resp) => {
                                swal
                                    .fire({
                                        title: "BERJAYA DI SIMPAN!",
                                        text: "CLICK OK UNTUK TERUSKAN.",
                                        icon: "success",
                                    })
                                    .then(() => {
                                        this.$router.push({
                                            name: "BUTIRAN MAKLUMAT PERIBADI",
                                            params: {
                                                ICNo: this.ProfilAwam.NoKP,
                                            },
                                        });
                                    });
                            })
                            .catch((err) => {
                                console.log("err:", err.response);
                            });
                    } else {
                        swal.fire({
                            title: `MASALAH DATABASE @ NETWORK.`,
                            buttonsStyling: true,
                            icon: "error",
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

    },
    created() {
        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log("SERVE",this.ServClassList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

    },
};
</script>

<style scoped>
/* Optional: Customize styles for better aesthetics */
h4 {
    font-weight: 600;
    text-transform: uppercase;
}

.stats-card2 {
    transition: transform 0.3s;
}

.stats-card2:hover {
    transform: scale(1.05);
    /* Scale up on hover */
}

.base-button {
    transition: background-color 0.3s;
}

.base-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Slight change on hover */
}
</style>
